import React from "react";
import "../Css/Scroll.css";
import { HiChevronDoubleUp } from "react-icons/hi";
class Scroll extends React.Component {

  render() {
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
    return (
      <div id="pos">
      <button onClick={()=>{topFunction();}} id="myBtn" title="Go to top" className="container-fluid"><i><HiChevronDoubleUp/></i></button>
      </div>
    );
  }
}
export default Scroll;
